<template>
    <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" class="notification-modal" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader" />

            <div class="box">
                <div class="col-sm-12 col-md-10 pl-0 float-left mb-5">
                    <h2 v-if="this.tableId == 'hiring' && preloader">{{ $t("reject_candidate") }}?</h2>
                    <h2 v-else-if="this.tableId == 'hiring'">{{ $t("reject_candidate") }} {{ inputs.name }}?</h2>
                    <h2 v-else-if="preloader">{{ $t("really_delete_candidate") }}?</h2>
                    <h2 v-else-if="this.tableId == 'onboarding'" class="mb-3">{{ $t("really_move_employee_to_talentpool") }} {{ inputs.name }}?</h2>
                    <h2 v-else class="mb-3">{{ $t("really_delete_candidate") }} {{ inputs.name }}?</h2>

                    <div v-if="(this.tenant == 'studioreaktor' || this.tenant == 'localhost') && this.tableId == 'hiring'">
                        <div class="mb-4 tab-comment-data">
                            <app-mailbox-add-form :table-id="tableMailboxId" :action="'rejection'" :candidate-id="this.inputs.id" :candidate-name="this.inputs.name+' '+this.inputs.surname" :candidate-mail="this.inputs.mailto" :subject="this.mailboxOptions.total > 0 ? mailboxOptions.data[0].subject : 'Nová zpráva pro uchazeče o zaměstnání'" :user-name="user.loggedInUser.full_name" :user-photo="user.loggedInUser.img" class="loading-hidden" @changed="getMailbox()"></app-mailbox-add-form>
                            <app-mailbox v-if="mailboxLoaded" :table-id="tableMailboxId" :mailbox-messages="this.mailboxOptions" class="loading-hidden"></app-mailbox>
                        </div>
                    </div>

                    <form v-if="(this.tenant != 'studioreaktor' && this.tenant != 'localhost') && this.tableId == 'onboarding'" class="mb-5" :class="{ 'loading-opacity': preloader }" ref="form">
                        <div class="form-group row align-items-center mt-5">
                            <app-input id="checkbox_talentpool" class="col-sm-9" type="checkbox" :list="talentpoolSelection" v-model="inputs.talentpool" />
                        </div>
                    </form>

                    <form v-if="(this.tenant != 'studioreaktor' && this.tenant != 'localhost') && this.tableId == 'hiring'" class="mb-5" :class="{ 'loading-opacity': preloader }" ref="form">
                        <div class="form-group row align-items-center mt-5">
                            <app-input id="checkbox_talentpool" class="col-sm-9" type="checkbox" :list="talentpoolSelection" v-model="inputs.talentpool" />

                            <app-input id="checkbox_notification" class="col-sm-12 mt-2" type="checkbox" :list="notificationSelection" v-model="inputs.sendMail" />
                        </div>
                        <div v-if="this.inputs.sendMail == 1" class="row col-sm-12 col-md-9 justify-content-between half-width-container pr-0 mt-0 mb-2">
                            <div class="form-group row align-items-center md-half-width pr-md-2">
                                <label for="inputs_subject" class="col-sm-12 mt-3 mb-2">
                                    {{ $t("subject") }}
                                </label>
                                <app-input id="inputs_subject" class="col-sm-12" type="text" v-model="inputs.subject" />
                            </div>
                            <div class="form-group row align-items-center md-half-width">
                                <label for="inputs_title" class="col-10 mt-3 mb-2 pl-0">
                                    {{ $t("choose_from_template") }}
                                </label>
                                <a href="/mail-templates" target="_blank" class="col-2 mt-1 text-right text-muted" :title="$t('edit_templates')">
                                    <app-icon :name="'edit'" width="18" height="18" />
                                </a>

                                <app-input id="inputs_template" class="pr-0 w-100" type="select" v-model="template" :list="templateOptions" />
                            </div>
                        </div>

                        <div class="form-group row align-items-center">
                            <app-overlay-loader v-if="editorPreloader" />
                            <app-input v-if="this.inputs.sendMail == 1" id="inputs_message" class="col-sm-9 pr-1" type="text-editor" v-model="inputs.message" :placeholder="$t('text_type_input')" />
                            <app-input v-if="editorPreloader" id="inputs_text_blind" class="col-sm-12" :class="{ 'loading-opacity': editorPreloader }" type="textarea" />
                        </div>

                        <i v-if="this.inputs.sendMail == 1">E-mail nebude odeslán hromadně – zamítnutí každému uchazeči odešleme zvlášť.</i><br /><br />

                        <div v-if="this.inputs.talentpool == 1" class="note note-info row text-center ml-1 mb-5">
                            <div class="mt-3 mb-3">
                                <i class="custom-icon custom-icon-shield float-left mr-2 ml-5"></i>
                                {{ $t("notification_gdpr_claim") }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-sm-12 col-md-2 mt-5 float-left text-center p-0 mb-5">
                    <img src="/images/illustration_error.svg" style="width: 200px;" />
                </div>
            </div>

            <div class="clearfix"></div>
        </template>
    </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
    name: "RejectionModal",
    extends: AppLibrary,
    mixins: [FormMixin, ModalMixin, UserMixin],
    props: {
        tableId: String,
        selectedRows: Array,
        modalType: String,
    },
    watch: {
        template: {
            sync: true,
            handler(val, oldVal) {
                if (val != 0) {
                    this.getTemplateData();
                }
            },
        },
    },
    data() {
        return {
            preloader: false,
            editorPreloader: false,
            finishedGetData: false,
            template: 0,
            templateOptions: [{ id: 0, value: this.$t("select") }],
            mailboxOptions: [],
            tenant: "",

            inputs: {
                event_type: "rejection",
                event_date: "",
                mailto: "",
                replyto: "",
                subject: "",

                name: "",
                email: "",
                status: "",
                candidate_id: 0,
                delete: 1,
                sendMail: ["1"],
                talentpool: ["1"],
                template: ["1"],
            },
            notificationSelection: [{ id: "1", value: this.$t("send_notification_to_customer") }],
            talentpoolSelection: [{ id: "1", value: this.$t("save_to_talentpool") }],

            modalId: "rejection-Modal",
            modalTitle: this.$t("add"),
            value: {},
        };
    },
    created() {
        if (this.selectedCandidates) {
            this.preloader = true;
        }

        // Display available job templates
        let url = "admin/app/templates?filter_with_status_id=1&per_page=500";
        this.axiosGet(url)
            .then((response) => {
                const templateOptionsArray = response.data.data.map(({ name: value, ...rest }) => ({
                    value,
                    ...rest,
                }));

                this.templateOptions = templateOptionsArray;
                this.templateOptions.unshift({ id: 0, value: this.$t("select") });
            })
            .catch(({ response }) => {})
            .finally(() => {
                this.finishedGetData = true;
            });
    },
    mounted() {
        let candidateDetails = this.selectedRows.map((candidateDetails) => {
            return candidateDetails.fullname;
        });
        this.inputs.name = Object.values(candidateDetails).join(", ");

        candidateDetails = this.selectedRows.map((candidateDetails) => {
            return candidateDetails.email;
        });
        this.inputs.mailto = Object.values(candidateDetails).join(",");

        candidateDetails = this.selectedRows.map((candidateDetails) => {
            return candidateDetails.id;
        });
        this.inputs.candidate_id = Object.values(candidateDetails).join(",");
        this.inputs.id = Object.values(candidateDetails).join(",");

        candidateDetails = this.selectedRows.map((candidateDetails) => {
            return candidateDetails.timeline_state;
        });
        this.inputs.timeline_state = Object.values(candidateDetails).join(",");

        let message = "";
        let photo = "";
        if (this.user.loggedInUser.img) {
            photo = '<td style="width: 100px"><img src="' + window.location.origin + this.user.loggedInUser.img + '" alt="User profile photo" height="60"></td>';
        }
        let messageSuffix = 'S pozdravem <br><table align="left"><tbody><tr>' + photo + "<td><b>" + this.user.loggedInUser.full_name + "</b><br>" + this.user.loggedInUser.roles[0].name + "<br>" + this.user.loggedInUser.email + "</td></tr></tbody></table><br><br><br>";

        this.inputs.message = "Doplňte text zprávy...<br><br>" + message + "<br>" + messageSuffix;
        this.inputs.replyto = this.user.loggedInUser.email;
        this.getTenantSettings();
        this.getMailbox();
        this.preloader = false;
    },
    methods: {
        setFormData() {},
        beforeSubmit() {
            this.preloader = true;
        },
        submit() {
            this.prepareNotification();
        },
        sendBulkEdits() {
            let candidateDetails = this.selectedRows.map((candidateDetails) => {
                return candidateDetails.name;
            });
            this.inputs.name = Object.values(candidateDetails).join(", ");

            candidateDetails = this.selectedRows.map((candidateDetails) => {
                return candidateDetails.email;
            });
            this.inputs.mailto = Object.values(candidateDetails).join(",");

            candidateDetails = this.selectedRows.map((candidateDetails) => {
                return candidateDetails.id;
            });
            this.inputs.id = Object.values(candidateDetails).join(",");

            if (this.inputs.talentpool[0] == 1) {
                this.inputs.delete = 0;
                this.inputs.timeline_state = 1; // talentpool => hiring on timeline_state 1, not last timeline_state
                this.inputs.status = 1;
            } else {
                this.inputs.delete = 1;
            }
            console.log(this.inputs);

            // Hard delete on talentpool
            if (this.tableId == "talentpool") {
                this.inputs.delete = 1;
                this.inputs.status = 1;
            } else if (this.tableId == "hiring") {
                this.inputs.status = 2;
            } else if (this.tableId == "onboarding") {
                this.inputs.status = 3;
            }

            // admin/app/bulk/edit-candidates?candidate_id=27&status=1&notification=1&delete=0
            this.axiosPatch({
                url: "admin/app/bulk/edit-candidates",
                data: this.inputs,
            })
                .then((response) => {
                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }
                })
                .finally(() => {
                    this.$hub.$emit("reload-" + this.tableId);
                });
        },
        prepareNotification() {
            this.preloader = true;
            this.inputs.email = "podpora@onboardio.pro";

            // Send to others (delay because of proper mail sending)
            let mailTos = this.inputs.mailto.split(","); // ['podpora@onboardio.pro', 'info@onboardio.pro'];
            let ids = this.inputs.id.split(",");
            let names = this.inputs.name.split(",");

            // Always send separate app notifications (because we need to store each entry for a candidate in his history)
            // Rejection, Notification
            let i = 0;
            let _this = this;

            for (let i = 0; i < mailTos.length; i++) {
                setTimeout(function timer() {
                    _this.inputs.id = ids[i];
                    _this.inputs.name = names[i];
                    _this.sendAppNotifications();
                    console.log("odesílám app notifikaci s " + _this.inputs.name);
                }, i * 50);
            }

            // Send separate mails for each rejection
            if (this.inputs.message && this.inputs.subject && this.inputs.sendMail == 1) {
                if (this.inputs.event_type == "rejection") {
                    let i = 0;
                    let _this = this;

                    for (let i = 0; i < mailTos.length; i++) {
                        setTimeout(function timer() {
                            _this.inputs.mailto = mailTos[i];
                            _this.inputs.id = ids[i];
                            _this.inputs.name = names[i];
                            _this.sendMailNotifications();
                            console.log("odesílám " + i + ". email s " + mailTos[i] + " " + mailTos.length);
                        }, (i + 1) * 500);
                    }

                    // On delete anonymize data after sending all messages
                    setTimeout(function timer() {
                        _this.sendBulkEdits();
                    }, (mailTos.length + 1) * 500);
                }
            } else {
                setTimeout(function timer() {
                    _this.sendBulkEdits();
                }, (mailTos.length + 1) * 500);

                setTimeout(function timer() {
                    this.preloader = false;
                    $(".floating-bar-fixed-bottom")
                        .addClass("animate__fadeOut")
                        .delay(100)
                        .fadeOut();
                    setTimeout(function() {
                        $("#rejection-Modal").modal("hide");
                    }, 10);
                }, (mailTos.length + 1) * 500);
            }
        },
        sendAppNotifications() {
            // Push predefined automatic in-app notification and/or e-mail
            this.axiosPatch({
                url: "admin/app/candidates-app-notifications",
                data: this.inputs,
            })
                .then((response) => {})
                .finally(() => {});
        },
        sendMailNotifications() {
            this.axiosPatch({
                url: "admin/app/candidates-mail-notifications",
                data: this.inputs,
            })
                .then((response) => {
                    if (response.data) {
                        this.afterSuccess(response);
                    } else {
                        this.afterError(response);
                    }
                })
                .finally(() => {
                    this.preloader = false;
                    $(".floating-bar-fixed-bottom")
                        .addClass("animate__fadeOut")
                        .delay(100)
                        .fadeOut();
                    setTimeout(function() {
                        $("#rejection-Modal").modal("hide");
                    }, 10);
                });
        },
        getMailbox() {
            if((this.tenant == "studioreaktor" || this.tenant == "localhost") && (this.inputs.email || this.inputs.mailto)){
                let url = "admin/app/mailbox", 
                    reqData = {};

                reqData.params = {
                    from: this.inputs.email ? this.inputs.email : this.inputs.mailto,
                };

                this.axiosGet(url, reqData)
                    .then((response) => {
                        this.mailboxOptions = response.data;
                        this.mailboxLoaded = true;
                    })
                    .catch(({ response }) => {})
                    .finally(() => {});
            }
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
        },
        afterSuccess(response) {
            this.$toastr.s(this.$t(response.data));
        },
        afterError(response) {
            this.$toastr.s(this.$t(response.data));
        },
        clear() {
            this.inputs = {};
        },

        /**
         * Fill from Template
         */
        getTemplateData() {
            let photo = "";
            if (this.user.loggedInUser.img) {
                photo = '<td style="width: 100px"><img src="' + this.user.loggedInUser.img + '" alt="User profile photo" height="60"></td>';
            }
            let messageSuffix = '<table align="left"><tbody><tr>' + photo + "<td><b>" + this.user.loggedInUser.full_name + "</b><br>" + this.user.loggedInUser.roles[0].name + "<br>" + this.user.loggedInUser.email + "</td></tr></tbody></table><br><br><br>";

            let selectedTemplateId = parseInt(this.template);
            let templates = this.templateOptions;
            const selectedTemplate = templates.find((o) => o.id === selectedTemplateId);

            this.finishedGetData = false;
            this.editorPreloader = true;
            this.inputs.title = selectedTemplate.title;
            this.inputs.message = selectedTemplate.body + messageSuffix;

            let _this = this;
            setTimeout(function() {
                _this.finishedGetData = true;
                _this.editorPreloader = false;
            }, 500);
        },

        /**
         * Tenant-based modifications
         */
        getTenantSettings() {
            if (window.location.href.indexOf("localhost") > -1) {
                this.tenant = "localhost";
            } else {
                this.tenant = window.location.host.split(".")[0];
            }
            
        },
    },
};
</script>
